import { render } from "./searchTables.vue?vue&type=template&id=74c708ca"
import script from "./searchTables.vue?vue&type=script&lang=js"
export * from "./searchTables.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__